import { Controller } from "@hotwired/stimulus"

// Handles preset shortcut buttons in FilterBarComponent.
// Clicking a preset fills the start/end date inputs without submitting;
// the user still hits "Apply" to load results.
export default class extends Controller {
  static targets = ["startDate", "endDate"]

  connect() {
    // Defer by one macrotask so all other controllers on the page (including
    // notification_controller at the bottom of <body>) have finished connecting
    // and registered their event listeners before we potentially dispatch.
    setTimeout(() => this.#checkDates(), 0)
  }

  setPreset(event) {
    event.preventDefault()
    const { start, end } = event.params
    if (this.hasStartDateTarget) this.startDateTarget.value = start
    if (this.hasEndDateTarget)   this.endDateTarget.value   = end
    this.#clearError()
  }

  validateDates(event) {
    if (this.#checkDates()) event.preventDefault()
  }

  // ── private ────────────────────────────────────────────────────────────────

  // Returns true (and shows the error) when start > end, false otherwise.
  #checkDates() {
    if (!this.hasStartDateTarget || !this.hasEndDateTarget) return false

    const start = this.startDateTarget.value
    const end   = this.endDateTarget.value

    if (start && end && start > end) {
      this.#showError()
      return true
    }

    this.#clearError()
    return false
  }

  #showError() {
    window.dispatchEvent(new CustomEvent("notification:show", {
      detail: {
        title:   "Invalid date range",
        message: "Start date must be before end date.",
        type:    "error"
      }
    }))
    this.startDateTarget.classList.add("outline-red-500", "outline-2")
    this.endDateTarget.classList.add("outline-red-500", "outline-2")
  }

  #clearError() {
    if (this.hasStartDateTarget) {
      this.startDateTarget.classList.remove("outline-red-500", "outline-2")
    }
    if (this.hasEndDateTarget) {
      this.endDateTarget.classList.remove("outline-red-500", "outline-2")
    }
  }
}
